"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import c from "react";
import { s as d } from "./ChevronRightIcon-iheg0enf.mjs";
import { t as p } from "./tv.config-BuYIgndg.mjs";
const u = p({
  slots: {
    root: [
      "Breadcrumb__root",
      "flex",
      "flex-wrap",
      "list-none",
      "rounded-small",
      "text-primary-light",
      "my-2"
    ],
    listItem: [
      "[&>*]:!no-underline",
      "[&>*]:cursor-pointer",
      "[&>*]:last:cursor-default",
      "[&>*]:text-sm",
      "font-bold",
      "[&>*]:last:!font-regular",
      "[&>*]:last:!text-slate-400",
      "[&>*]:leading-none",
      "[&>*]:appearance-none",
      "Breadcrumb__item",
      "flex items-center"
    ],
    separator: ["[&_svg]:size-4", "text-slate-400"]
  },
  variants: {
    size: {
      small: {
        listItem: ["[&>*]:text-xs"],
        separator: ["[&_svg]:size-4"]
      },
      medium: {
        listItem: ["[&>*]:text-sm"],
        separator: ["[&_svg]:size-5"]
      },
      large: {
        listItem: ["[&>*]:text-lg"],
        separator: ["[&_svg]:size-6"]
      }
    }
  },
  defaultVariants: {
    size: "small"
  }
}), {
  root: x,
  listItem: f,
  separator: b
} = u();
function j(a) {
  const { children: l, separator: o, size: t, className: m } = a, s = c.Children.toArray(l), i = s.map((n, r) => /* @__PURE__ */ e.jsxs("li", { className: f({ size: t }), children: [
    n,
    r + 1 !== (s == null ? void 0 : s.length) && /* @__PURE__ */ e.jsx("span", { className: b({ size: t }), children: o || /* @__PURE__ */ e.jsx(d, {}) })
  ] }, r));
  return /* @__PURE__ */ e.jsx(
    "ol",
    {
      className: x({
        size: t,
        class: m
      }),
      children: i
    }
  );
}
export {
  j as default
};
